import { useSelector as use, TypedUseSelectorHook } from "react-redux";
import { RootState } from "store";

const useSelector: TypedUseSelectorHook<RootState> = use;

export default useSelector;
